import { render, staticRenderFns } from "./list-photo.vue?vue&type=template&id=0bc24ef2&"
import script from "./list-photo.vue?vue&type=script&lang=js&"
export * from "./list-photo.vue?vue&type=script&lang=js&"
import style0 from "./list-photo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports